import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { WishlistToggleComponentDef } from '@df/session/wishlist/wishlist-toggle.component.def';

@Component({
    selector: 'product-wishlist-toggle',
    templateUrl: 'product-wishlist-toggle.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductWishlistToggleComponent extends WishlistToggleComponentDef implements OnInit {}
